import { useAuth } from '../store/useAuth'

/**
 * THE PASS HAS ENDED, AND EVERYTHING IS STILL HERE.
 *
 * A bar across the top rather than a wall in front of the app, because the
 * work is not being withheld. Every job, every customer and every quote opens
 * and reads exactly as before. What stops is making new ones.
 *
 * It says that plainly and first. The fear on seeing anything about an expired
 * account is that the season is gone, and a person who believes that for ten
 * seconds is a person who has already started looking for a way to export it
 * all in a panic.
 *
 * No payment form here. Billing lives on the site with the card details, and a
 * checkout on this side would be a second place money changes hands.
 */

import { SITE } from '../lib/brand'

export default function Lapsed() {
  const access = useAuth((s) => s.access)

  return (
    <div className="lapsed" role="status">
      <span className="lapsed-what">
        <strong>
          {access === 'expired' ? 'Your season pass has ended.' : 'This account is not active.'}
        </strong>{' '}
        Everything you have ever drawn is still here and still opens. You cannot start
        anything new until it is renewed.
      </span>
      <a className="btn primary" href={`${SITE}/#pricing`}>
        Renew
      </a>
    </div>
  )
}
